export default class expertPage {
  constructor () {
    $('.expert-content--links a').each(function(){
      // $(this).spanify();
      $(this).addClass('kash ktxt');
    }); //.kashify();

    setTimeout(function(){
      $('.expert-content--wrap > div').addClass('bgs');
    }, 500);

    if(MOBSIZE) {
      $('.expert-content--wrap').scroll(function(){
        // $('.expert-content--wrap > *').each(function(){
        //   if(this.getBoundingClientRect().top < 80){
        //     $(this).addClass('out');
        //   } else {
        //     $(this).removeClass('out');
        //   }
        // });
        if($('.expert-content--bio').length > 0){
          let bio = $('.expert-content--bio').get(0);
          let rect = bio.getBoundingClientRect();
          console.log(rect.top);
          if(rect.top <= window.innerHeight*.8) {
            let val = (rect.top - 100) / (window.innerHeight * .8);
            val = Math.max(0, val);
            console.log(val);
            $('.expert-ascii-photo').css('opacity', val);
            // $('.expert-ascii-photo').addClass('out');
          } else {
            $('.expert-ascii-photo').css('opacity', .8);
            // $('.expert-ascii-photo').css('opacity',1);
            // $('.expert-ascii-photo').removeClass('out');
          }
        }
      });
    }
  }
}
